import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import Icon from 'components/lib/ui/Icon';

import useEventCallback from 'common/lib/hooks/useEventCallback';
import { useCommandRegistry } from 'lib/commands/context';
import type { MonarchCommandGroup } from 'lib/commands/types';
import { getIsSideDrawerVisible } from 'state/ui/selectors';

const GROUP: MonarchCommandGroup = 'actions';
const TOGGLE_SUMMARY_COLUMN_SHORTCUT_KEYS = [']'];

type UseTransactionCommandsOptions = {
  toggleSummaryColumnVisibility: () => void;
};

export const useTransactionsRouteCommands = ({
  toggleSummaryColumnVisibility,
}: UseTransactionCommandsOptions) => {
  const isSideDrawerOpen = useSelector(getIsSideDrawerVisible);
  const { registerCommand } = useCommandRegistry();
  const toggleSummaryColumn = useEventCallback(() => {
    toggleSummaryColumnVisibility();
  });

  useEffect(() => {
    // Don't register the command if the side drawer is open
    if (isSideDrawerOpen) {
      return;
    }

    const unbindCommand = registerCommand({
      group: GROUP,
      id: 'transactions.toggle-summary-column',
      label: 'Toggle summary column',
      action: toggleSummaryColumn,
      keys: TOGGLE_SUMMARY_COLUMN_SHORTCUT_KEYS,
      icon: <Icon name="sidebar-right" />,
      analyticsMetadata: {
        analyticsId: 'transactions.toggle-summary-column',
      },
    });

    return () => {
      unbindCommand();
    };
  }, [registerCommand, toggleSummaryColumn, isSideDrawerOpen]);

  return {
    toggleSummaryColumnShortcut: TOGGLE_SUMMARY_COLUMN_SHORTCUT_KEYS,
  };
};
